import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { navigate } from 'gatsby';
import rehypeRaw from 'rehype-raw';

import { useDispatch } from 'react-redux';
import { hide } from '../store/sub_modal';

import CloseIcon from '../assets/icons/close.svg';
import { CollapsibleBlock } from './CollapsibleBlock';
import posthog from 'posthog-js';

export default function SubscriptionModal({ data }) {
  const dispatch = useDispatch();

  const closeModal = () => {
    localStorage.setItem('subscription_modal_closed', new Date().toISOString().substring(0, 10));
    dispatch(hide());
  };

  const backgroundStyle = data?.backgroundUrl
    ? {
        backgroundImage: `url(${data.backgroundUrl})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }
    : {};

  const mainButtons = data.mainButtons ?? [];
  const documentButtons = data.documentButtons ?? [];

  const goToSubscriptions = () => {
    posthog.capture('subscription_checkout_started');
    navigate('/subscriptions');
    closeModal();
  };

  return (
    <div className="modalWrapper">
      <div className="wideModal scrollable" style={backgroundStyle}>
        <img
          className="modal-close-button"
          src={CloseIcon}
          alt="Close button for modal"
          onClick={closeModal}
        />
        <div className="text-center pb-1">
          <h2>Join MyMathsCloud</h2>
        </div>

        {data?.content && (
          <ReactMarkdown
            className="paragraph mb-1"
            rehypePlugins={[rehypeRaw]}
            children={data.content}
          />
        )}

        <div className="text-center">
          {mainButtons?.length > 0 && (
            <div className="samples-container">
              {mainButtons.map(({ label, link }, i) => (
                <a
                  className="button w-button"
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {label}
                </a>
              ))}
            </div>
          )}
        </div>

        <CollapsibleBlock
          data={{
            title: 'View Sample Documents',
            content: (
              <div>
                {documentButtons?.length > 0 && (
                  <div className="samples-container small mb-1">
                    {documentButtons.map(({ label, link }, i) => (
                      <a
                        href={link}
                        key={`pdflink-${i}`}
                        className="button w-button"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ),
          }}
        />

        <div className="modalFooter">
          <button onClick={closeModal}>Close</button>
          <button
            className="button w-button"
            key={data?.callToActionText}
            onClick={goToSubscriptions}
          >
            {data?.callToActionText || 'Join Now'}
          </button>
        </div>
      </div>
    </div>
  );
}
